/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hslope_AverageInputs */



/**
* | output |
* | --- |
* | "Average network heating rise speed" |
*
* @param {Hslope_AverageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const hslope_average = /** @type {((inputs?: Hslope_AverageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hslope_AverageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average network heating rise speed")
	return /** @type {LocalizedString} */ ("Moyenne des vitesses de monté en chauffe du réseau")
});